export default __webpack_public_path__ + "e49401c8de02d78730791971172d457b.png";